// This function tokenizes a payment method.
// The ‘error’ thrown from this async function denotes a failed tokenization,
// which is due to buyer error (such as an expired card). It is up to the
// developer to handle the error and provide the buyer the chance to fix
// their mistakes.
export default async function tokenize(paymentMethod) {
  const tokenResult = await paymentMethod.tokenize()
  if (tokenResult.status === 'OK') {
    return tokenResult.token
  } else {
    let errorMessage = `Tokenization failed-status: ${tokenResult.status}`
    if (tokenResult.errors) {
      errorMessage += ` and errors: ${JSON.stringify(tokenResult.errors)}`
    }
    throw new Error(errorMessage)
  }
}
